import { Shield, RefreshCw, Headphones } from "lucide-react";

export function Guarantees() {
    const guarantees = [
        { icon: RefreshCw, title: "Otimização Contínua", desc: "Ajustamos campanhas diariamente para maximizar seus resultados." },
        { icon: Shield, title: "Implementação Total", desc: "Cuidamos de tudo: desde a configuração até a operação." },
        { icon: Headphones, title: "Suporte Ágil", desc: "Equipe dedicada para tirar dúvidas e resolver problemas rapidamente." },
    ];

    return (
        <section className="py-20 bg-slate-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Nossas garantias</h2>
                    <p className="text-slate-600 text-lg">Segurança e compromisso com seu sucesso</p>
                </div>
                <div className="grid md:grid-cols-3 gap-8">
                    {guarantees.map((g, i) => (
                        <div key={i} className="bg-white rounded-2xl p-8 shadow-lg text-center">
                            <div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <g.icon className="w-8 h-8 text-brand-600" />
                            </div>
                            <h3 className="text-xl font-bold text-slate-900 mb-2">{g.title}</h3>
                            <p className="text-slate-600">{g.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
